import { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import GoogleMap from "google-map-react";

import { getThemeClasses } from "@utils/bestInTravel/2025/getThemeClasses";

import { Marker } from "./marker";
import styles from "./styles/book.json";

export function MapDisplay({ mapData, inactiveMarkers = [] }) {
  const mapRef = useRef(null);

  const setupMap = useCallback(
    ({ map, maps }) => {
      // eslint-disable-next-line no-param-reassign
      mapRef.current = map;
      const config = {
        mapTypeControl: false,
        fullscreenControl: true,
        streetViewControl: false,
        styles,
        zoomControl: true,
        zoomControlOptions: {
          position: maps.ControlPosition.RIGHT_TOP,
        },
      };
      map.setOptions(config);

      const bounds = new maps.LatLngBounds();
      mapData.forEach(destination => {
        bounds.extend(new maps.LatLng(destination.lat, destination.lng));
      });

      const padding = 50;
      map.fitBounds(bounds, { padding });
    },
    [mapRef, mapData]
  );

  return (
    <div className="w-full h-screen-dvh">
      <GoogleMap
        bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY }}
        defaultZoom={1}
        yesIWantToUseGoogleMapApiInternals
        center={{ lat: 0, lng: 0 }}
        onGoogleApiLoaded={setupMap}
      >
        {inactiveMarkers.map(inactiveDestination => (
          <Marker
            key={`Marker-${inactiveDestination.name}`}
            inactiveMarker
            {...inactiveDestination}
          />
        ))}
        {mapData.map((destination, index) => (
          <Marker
            key={`Marker-${destination.name}`}
            themeClasses={getThemeClasses(destination.category)}
            index={index}
            {...destination}
          />
        ))}
      </GoogleMap>
    </div>
  );
}

MapDisplay.propTypes = {
  mapData: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      name: PropTypes.string,
      category: PropTypes.string,
    })
  ).isRequired,
  inactiveMarkers: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      name: PropTypes.string,
      category: PropTypes.string,
    })
  ),
};
